export default __webpack_public_path__ + "static/media/footerarrowdown.dd501477.png";